import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";

const Weekstaten = () => {
    return (
        <Outlet />
    )
};

export default Weekstaten;
